import request from '../utils/request';
//根据路由id找到对应分类
export function toCode(data) {
  return request({
    url: '/wap/adPicture/toCode.html',
    method: 'post',
    data
  })
}
//根据路由id找到对应分类-拼团
export function toNewCode(data) {
  return request({
    url: '/wap/adPicture/toNewCode.html',
    method: 'post',
   data
  })
}
//获取数据
export function toClassCenter(data) {
  return request({
    url: '/wap/class/toClassCenter.html',
    method: 'post',
    data
  })
}
//获取数据-拼团
export function toClassCenterPt(data) {
  return request({
    url: '/wap/class/toClassCenterPt.html',
    method: 'post',
    data
  })
}
//生成订单
export function toGeneratePxOrder(data) {
  return request({
    url: '/wap/tyOrder/toGeneratePxOrder.do',
    method: 'post',
    data
  })
}
//试看
export function toTry(data) {
  return request({
    url: 'wap/class/toTry.html',
    method: 'post',
    data
  })
}

//拼团信息接口
export function findPinTuanInfo(data) {
  return request({
    url: '/wap/tyUser/findPinTuanInfo.html',
    method: 'post',
    data
  });
}
//拼团判断是否是移动端
export function isPintuanMobile(data) {
  return request({
    url: '/wap/tyUser/isPintuanMobile.html',
    method: 'post',
    data
  });
}